import { DateTime } from 'luxon';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import { SubjectData } from 'shell/models/person';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';

export const transformGenerality = (subjectData: SubjectData): AccordionGeneralityForm => ({
  fiscalCode: subjectData.generalita?.codiceFiscale?.codFiscale || '',
  name: subjectData.generalita?.nome || '',
  surname: subjectData.generalita?.cognome || '',
  withoutName: subjectData.generalita?.senzaNome === '1' ? true : false,
  withoutSurname: subjectData.generalita?.senzaCognome === '1' ? true : false,
  validityFiscalCode: subjectData.generalita?.codiceFiscale?.descrizioneValiditaCF || '',
  validityFiscalCodeId: subjectData.generalita?.codiceFiscale?.validitaCF || '',
  validityDateFiscalCode: subjectData.generalita?.codiceFiscale?.dataAttribuzioneValidita
    ? DateTime.fromISO(subjectData.generalita?.codiceFiscale?.dataAttribuzioneValidita)
    : null,
  // birthChoiceDate?: Array<DatePickerView>;
  gender: subjectData.generalita?.sesso,
  aire: subjectData.generalita?.soggettoAIRE,
  expatriationYear: subjectData.generalita?.annoEspatrio,
  birthDate: subjectData.generalita?.dataNascita
    ? DateTime.fromISO(subjectData.generalita.dataNascita)
    : null,
  birthChoiceDate: transformToChoiceDate(
    subjectData?.generalita?.senzaGiorno || '',
    subjectData?.generalita?.senzaGiornoMese || ''
  ),
  italian: {
    location: subjectData.generalita?.luogoNascita?.comune?.descrizioneLocalita,
    municipality: {
      provinceCode: subjectData.generalita?.luogoNascita?.comune?.siglaProvinciaIstat,
      description: subjectData.generalita?.luogoNascita?.comune?.nomeComune || '',
      province: subjectData.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
    },
    province: subjectData.generalita?.luogoNascita?.comune?.siglaProvinciaIstat,
  },
  isForeign: !!subjectData.generalita?.luogoNascita?.localita?.codiceStato,
  foreign: {
    municipality: {
      id: subjectData.generalita?.luogoNascita?.localita?.codiceStato,
      description: subjectData.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
      province: subjectData.generalita?.luogoNascita?.localita?.provinciaContea || '',
    },
    state: {
      id: subjectData.generalita?.luogoNascita?.localita?.codiceStato || '',
      value: subjectData.generalita?.luogoNascita?.localita?.descrizioneStato || '',
    },
    province: subjectData.generalita?.luogoNascita?.localita?.provinciaContea || '',
  },
  exceptionalBirthPlace: subjectData.generalita?.luogoNascita?.luogoEccezionale,
  anprIdentifier: subjectData.generalita?.idSchedaSoggettoANPR,
  municipalityIdentifier:
    subjectData.generalita?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat,
  istatCode: subjectData.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto,
  note: subjectData.generalita?.note,
});
